import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=a47c52f6&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c52f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VIcon,VLayout})
